import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="pt-10 pb-16 relative" data-id="element-11">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-12">
        <div className="border-4 border-black p-8 bg-white text-black relative overflow-hidden" data-id="element-13">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-14">
            {/* Headshot on the left */}
            <motion.div className="relative" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-15">
              <div className="aspect-square overflow-hidden border-8 border-black relative" style={{
              borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%'
            }} data-id="element-16">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6dGwRtaBmWA7zBaRmUQdZN/headshot.jpg" alt="Dunja" className="w-full h-full object-cover" data-id="element-17" />
              </div>
            </motion.div>

            {/* Content on the right */}
            <div data-id="element-18">
              <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-19">
                JOIN THE DUNJA PARTY
              </h3>
              <p className="text-lg mb-8 leading-relaxed" data-id="element-20">
                Help me build the internet we deserve. Your support keeps this
                movement independent, ethical, and focused on creators—not
                shareholders.
              </p>

              <div className="mb-8" data-id="element-21">
                <h3 className="text-2xl font-bold mb-4" style={{
                color: '#9333EA'
              }} data-id="element-22">
                  Get a few emails a year, mostly updates on what I'm learning
                  and building and asks for help/intros
                </h3>
              </div>

              <motion.a href="https://dunjaparty.substack.com/" target="_blank" rel="noopener noreferrer" className="block w-full py-5 text-black font-bold text-xl border-4 border-black relative overflow-hidden text-center no-underline" style={{
              backgroundColor: '#00DD00'
            }} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} data-id="element-23">
                JOIN THE DUNJA PARTY
              </motion.a>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}